const cardYearCheck = () => import('@/pages/cardYearCheck/index')
const cardYearCheckDetail = () => import('@/pages/cardYearCheck/detail/index.vue')
const cardYearCheckPage = () => import('@/pages/cardYearCheck/check')
export default [
  {
    path: '/cardYearCheck',
    name: 'cardYearCheck',
    component: cardYearCheck,
    meta: {
      storeKey: 'mtc.renewal.operation'
    }
  },
  {
    path: '/cardYearCheckDetail',
    name: 'cardYearCheckDetail',
    component: cardYearCheckDetail,
    meta: {
    }
  },
  {
    path: '/cardYearCheckPage',
    name: 'cardYearCheckPage',
    component: cardYearCheckPage,
    meta: {
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/cardYearCheck/index.js